import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function HorizontalSeparatorIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "30.002"}
      height={height || "32"}
      viewBox="0 0 30.002 32"
    >
      <rect
        id="Rectangle_1942"
        data-name="Rectangle 1942"
        width="30.002"
        height="32"
        rx="5"
        fill="#f9f9f9"
      />
      <g id="Icon" transform="translate(5.998 8)">
        <rect
          id="Rectangle_1956"
          data-name="Rectangle 1956"
          width="18"
          height="16"
          fill="none"
        />
        <path
          id="Union_31"
          data-name="Union 31"
          d="M16.727,6a.5.5,0,0,1-.5-.5V3.875H1.778V5.5a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,5.5V.5A.5.5,0,0,1,.5,0h.774a.5.5,0,0,1,.5.5V2.125h14.45V.5a.5.5,0,0,1,.5-.5H17.5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5Z"
          transform="translate(0 5)"
          fill="#707070"
        />
      </g>
    </svg>
  );
}
